// extracted by mini-css-extract-plugin
export const post_container = "blog-post-module--post_container--V1hSU";
export const post_content = "blog-post-module--post_content--m0-UO";
export const siblinks = "blog-post-module--siblinks--YOTM9";
export const link = "blog-post-module--link--1SVQd";